/* eslint-disable import/prefer-default-export */
import reduxFreeFetcher, { simpleFetch as fetcher } from '@api/fetchers';
import { getHost, getCMSHost } from '@utils/api-helper/host';
import fetch from '@utils/api-helper/fetch';

const defaultHost = getHost();
const CMSHost = getCMSHost();

export const getStaticData = () => fetcher(`${CMSHost}api/offline-centres/`);

export const getCities = () =>
  fetcher(`${defaultHost}v1/offline_centres/cities`);

export const getOfflineCentrePlans = (city) =>
  fetcher(
    `${defaultHost}v1/subscriptions/offline/list/?city_uid=${city}&upgrade=true`
  );

export const getOfflineCentreDetails = (goalUID, centreUID) =>
  fetcher(
    `${CMSHost}api/city-specific-offline-centres/goal/${goalUID}/centre/${centreUID}/`
  );

export const getCentreDetails = (centreUID) =>
  fetcher(`${defaultHost}v1/asgard/centre/details?centre_uid=${centreUID}`);

export const fetchOfflineCityCentresOfAGoal = ({
  getState,
  url,
  body,
  onSuccess
}) => {
  return fetch(url, {
    getState,
    requestType: 'POST',
    body,
    onSuccess
  });
};

export const fetchOfflineCityCentresOfAGoalV2 = ({ body }) =>
  reduxFreeFetcher(`${defaultHost}v1/asgard/user/centres`, {
    body,
    requestType: 'POST'
  });

export const fetchOfflineSelectedCentre = ({ body }) =>
  reduxFreeFetcher(`${defaultHost}v1/asgard/user/selected-centre`, {
    body,
    requestType: 'POST'
  });

export const fetchEducatorsDetails = ({ body }) => {
  return reduxFreeFetcher(`${defaultHost}v1/user/offline/educator-details`, {
    body,
    requestType: 'POST'
  });
};

export const bookASlotForCentreVisit = ({ body }) => {
  const url = `${defaultHost}v1/asgard/user/book-visit`;
  // const tempURL = `${defaultHost}v1/asgard/user/centres`;
  return reduxFreeFetcher(url, {
    body,
    requestType: 'POST'
  });
};
